import cn from 'classnames';
import styles from './Accordion.module.scss';
import { ReactNode, useState } from 'react';

function AccordionArrow({ isOpen }: { isOpen: boolean }) {
  return (
    <img
      src="/svg/chevron-black.svg"
      alt="arrow"
      className={cn(styles.icon, { [styles.reversed]: isOpen })}
    />
  );
}

type AccordionProps = {
  title: string;
  children: ReactNode;
  className?: string;
  withPreview?: boolean;
};

export function Accordion({ title, children, className }: AccordionProps) {
  const accordionClassName = cn(styles.accordion, className);
  const [open, setOpen] = useState(false);

  const toggleOpening = () => {
    setOpen(!open);
  };

  const listClassName = cn(styles.list, {
    [styles.hidden]: !open,
  });

  return (
    <div className={accordionClassName}>
      <div
        onClick={toggleOpening}
        className={cn(styles.title, {
          [styles.titleActive]: open,
        })}
      >
        {title}
        <div className={styles.icon}>
          <AccordionArrow isOpen={open} />
        </div>
      </div>
      <div className={listClassName}>{children}</div>
    </div>
  );
}
